function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

export { _inheritsLoose as inheritsLoose };
//# sourceMappingURL=_rollupPluginBabelHelpers.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/node_modules/@stacks/network/dist/_virtual/_rollupPluginBabelHelpers.js
// module id = null
// module chunks = 